<template>
    <div class="dropbox file-upload">
        <div class="form-group">
            <input multiple type="file" class="form-control-file" aria-describedby="fileHelpId">
        </div>
    </div>
</template>

<script>
export default {
    name: 'file-upload'
}
</script>

<style>
.dropbox {
    outline: 1px dashed black; /* the dash box */
    outline-offset: -10px;    
    color: dimgray;
    padding: 10px 10px;
    min-height: 200px; /* minimum height */
    position: relative;
    cursor: pointer;
}

.input-file {
    opacity: 0; /* invisible but it's there! */
    width: 100%;
    height: 200px;
    position: absolute;
    cursor: pointer;
}

.dropbox p {
    font-size: 1.2em;
    text-align: center;
    padding: 50px 0;
}
</style>
